export default "__VITE_ASSET__BFjSn$xZ__"